import { NavLink } from "react-router-dom";

const items = [
  { label: "Inicio", to: "/", icon: "ri-home-5-line", iconActive: "ri-home-5-fill" },
  { label: "Servicios", to: "/servicios", icon: "ri-service-line", iconActive: "ri-service-fill" },
  { label: "Flota", to: "/flota", icon: "ri-truck-line", iconActive: "ri-truck-fill" },
  { label: "Solicitar", to: "/solicitar-servicio", icon: "ri-send-plane-line", iconActive: "ri-send-plane-fill", center: true },
  { label: "Contacto", to: "/contacto", icon: "ri-phone-line", iconActive: "ri-phone-fill" },
];

export default function MobileBottomNav() {
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 border-t border-background-200 bg-background-50/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-md lg:hidden"
      aria-label="Navegación inferior"
    >
      <ul className="flex items-stretch justify-between px-1">
        {items.map((item) => (
          <li key={item.to} className="flex-1">
            <NavLink
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `flex h-16 flex-col items-center justify-center gap-1 text-[11px] font-label font-medium transition-colors duration-200 ${
                  isActive ? "text-primary-600" : "text-foreground-500"
                }`
              }
            >
              {({ isActive }) =>
                item.center ? (
                  <>
                    <span className="flex h-10 w-10 -translate-y-3 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-md dark:text-foreground-950">
                      <i className={`${isActive ? item.iconActive : item.icon} text-xl leading-none`} aria-hidden="true"></i>
                    </span>
                    <span className="-mt-2">{item.label}</span>
                  </>
                ) : (
                  <>
                    <span className="flex h-6 w-6 items-center justify-center">
                      <i className={`${isActive ? item.iconActive : item.icon} text-xl leading-none`} aria-hidden="true"></i>
                    </span>
                    <span>{item.label}</span>
                  </>
                )
              }
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}